import { BrowserRouter, Route, Routes } from "react-router";
import Root from "./routes/Root.tsx";
import Home from "./routes/Home.tsx";
import Certifications from "./routes/Certifications.tsx";
import Exams from "./routes/Exams.tsx";
import TestEvents from "./routes/TestEvents.tsx";
import About from "./routes/About.tsx";
import Faqs from "./routes/Faqs.tsx";
import Resources from "./routes/Resources.tsx";
import ErrorPage from "./routes/ErrorPage.tsx";
import "./pre-tw.css"
import { createRoot } from "react-dom/client";
import { StrictMode } from "react";


createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route Component={Root}>
          <Route index Component={Home} />
          <Route path="/certifications" Component={Certifications} />
          <Route path="/exams" Component={Exams} />
          <Route path="/testing-events" Component={TestEvents} />
          <Route path="/about" Component={About} />
          <Route path="/faqs" Component={Faqs} />
          <Route path="/resources" Component={Resources} />
          {/* The following are legacy URLs to support outdated links */}
          <Route path="/testsites" Component={TestEvents} />
          <Route path="/links" Component={Resources} />
          <Route path="/examprep" Component={Exams} />
          <Route path="/faq" Component={Faqs} />
          <Route path="/tracks" Component={Certifications} />
          <Route path="/aboutus" Component={About} />
          <Route path="/contact" Component={Home} />
          {/* End legacy URLs */}
          <Route path="*" Component={ErrorPage} />
        </Route>
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
